import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { PrescriptionV3PrescriptionTypeEnum } from '@redteclab/api/clients/bully'
import { IconInfo } from '@redteclab/icons'

import { useOpenableControls } from '../../../../generic-hooks'
import { useGlobalConfigContext } from '../../../../global-config'
import { priceGetFormattedValueDiscount } from '../../../../price'
import { prescriptionAccessorGetPrescriptionLegalNote } from '../../../model/prescriptionAccessor/prescriptionAccessorGetPrescriptionLegalNote'
import { useProductPageContext } from '../../productPageContext'
import { ProductPrescriptionBonusDialog } from '../../ProductPrescriptionBonusDialog/ProductPrescriptionBonusDialog'

export const ProductBuyBoxPrescriptionBonusBadge: FC = () => {
  const modalControls = useOpenableControls()
  const { currentOffer, currentPrescriptionType } = useProductPageContext()
  const { superScripts } = useGlobalConfigContext()

  const intl = useIntl()

  const bonus =
    currentOffer?.prescriptionPriceMap?.[currentPrescriptionType]?.bonus

  if (!bonus || bonus <= 0) {
    return null
  }

  const isPrivatePrescription =
    currentPrescriptionType ===
    PrescriptionV3PrescriptionTypeEnum.PrivatePrescription
  const isPublicPrescription =
    currentPrescriptionType ===
      PrescriptionV3PrescriptionTypeEnum.InsurancePrescription ||
    currentPrescriptionType ===
      PrescriptionV3PrescriptionTypeEnum.FreePrescription

  return (
    <>
      <button
        className="flex gap-1 self-start rounded-3xl bg-light-secondary-medium pl-0.5 pr-1 tablet:mb-2"
        data-qa-id="product-buy-box-prescription-bonus-badge"
        onClick={modalControls.handleOpen}
        type="button"
      >
        <span className="my-0.5 rounded-3xl border border-dark-primary-min bg-light-primary-low px-3 py-1 text-xs font-medium text-dark-brand">
          {priceGetFormattedValueDiscount(bonus, intl)}
        </span>
        <span className="my-auto">
          {isPrivatePrescription ? (
            <FormattedMessage
              defaultMessage="Rezept-Bonus"
              id="general.prescriptionBonus.privatePrescription"
              values={{
                sup: (
                  <sup key="privateBonusBadge">
                    {prescriptionAccessorGetPrescriptionLegalNote(
                      currentPrescriptionType,
                      superScripts,
                    )}
                  </sup>
                ),
              }}
            />
          ) : null}
          {isPublicPrescription ? (
            <FormattedMessage
              defaultMessage="E-Rezept-Rabatt"
              id="general.prescriptionBonus.publicPrescription"
              values={{
                sup: (
                  <sup key="publicBonusBadge">
                    {prescriptionAccessorGetPrescriptionLegalNote(
                      currentPrescriptionType,
                      superScripts,
                    )}
                  </sup>
                ),
              }}
            />
          ) : null}
        </span>
        <span className="my-auto">
          <IconInfo className="size-4" />
        </span>
      </button>
      <ProductPrescriptionBonusDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </>
  )
}
